<router>
{
    name: 'Requests',
}
</router>
<template lang="pug">
v-container
    v-row
        v-col
            CustomerRequests

</template>
<script>

import CustomerRequests from '@/components/devops/requests';
export default {
    meta: {
        role: 'customersrequests'
    },
    components: {
        CustomerRequests,
    },
    data () {
        return {
        };
    },
    methods: {

    },
    computed: {

    },
    mounted () {
        window.customerrequestsvm = this;
    }
};
</script>

<style scoped>
</style>
